import { toArray as f } from "./array.js";
var x = function(t, a) {
  var n = Math.max(0, t.tabIndex), r = Math.max(0, a.tabIndex), e = n - r, i = t.index - a.index;
  if (e) {
    if (!n)
      return 1;
    if (!r)
      return -1;
  }
  return e || i;
}, u = function(t) {
  return t.tabIndex < 0 && !t.hasAttribute("tabindex") ? 0 : t.tabIndex;
}, d = function(t, a, n) {
  return f(t).map(function(r, e) {
    var i = u(r);
    return {
      node: r,
      index: e,
      tabIndex: n && i === -1 ? (r.dataset || {}).focusGuard ? 0 : -1 : i
    };
  }).filter(function(r) {
    return !a || r.tabIndex >= 0;
  }).sort(x);
};
export {
  d as orderByTabIndex,
  x as tabSort
};
//# sourceMappingURL=tabOrder.js.map
